import React from 'react';

interface StackNavigatorProps {
  initialRouteName: string;
  children: (...args: unknown[]) => unknown;
}

export default class StackNavigator extends React.PureComponent<StackNavigatorProps> {
  constructor(props) {
    super(props);
    this.state = { viewHistory: [props.initialRouteName], focusHistory: [] };
  }

  getLastEntry = () => {
    const { viewHistory } = this.state;
    return viewHistory[viewHistory.length - 1];
  };

  getNextFocusableElement = () => {
    const { focusHistory } = this.state;
    return focusHistory[focusHistory.length - 1];
  };

  push = (id) => {
    this.setState((state) => ({
      ...state,
      viewHistory: [...state.viewHistory, id],
      focusHistory: [...state.focusHistory, id]
    }));
  };

  pop = () => {
    if (this.state.viewHistory.length > 1) {
      this.setState(
        (state) => ({
          ...state,
          viewHistory: state.viewHistory.slice(0, -1)
        }),
        this.popFocusHistory
      );
    }
  };

  popFocusHistory = () => {
    if (this.state.focusHistory.length > 0) {
      this.setState((state) => ({
        ...state,
        focusHistory: state.focusHistory.slice(0, -1)
      }));
    }
  };

  render() {
    const { push, pop, getLastEntry } = this;
    return this.props.children({
      push,
      pop,
      pathname: getLastEntry(),
      focusElement: this.getNextFocusableElement()
    });
  }
}
